export const numberFormatter = (number: any) => {
  number = number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return number;
};
